import { createSlice } from "@reduxjs/toolkit";
import POD from "../../ts/models/POD";
import CommonMaster from "../../ts/models/CommonMaster";
import InfoQuestion from "../../ts/models/InfoQuestion";

type InitialState = {
  pod: POD;
  disclaimers: CommonMaster[];
  infoQuestions: InfoQuestion[];
  productInfoQuestions: InfoQuestion[];
  resourceName: string;
};

const emptyPod = { ...new POD() };

const initialState: InitialState = {
  pod: emptyPod,
  disclaimers: [],
  infoQuestions: [],
  productInfoQuestions: [],
  resourceName: localStorage.getItem("resourceName") || "cimpar",
};

const pod = createSlice({
  name: "pod",
  initialState,
  reducers: {
    getPOD: (state, action) => {
      state.pod = action.payload;
    },
    getPODDisclaimers: (state, action) => {
      state.disclaimers = action.payload;
    },
    getPODInfoQuestions: (state, action) => {
      state.infoQuestions = action.payload;
    },
    getProductInfoQuestions: (state, action) => {
      state.productInfoQuestions = action.payload;
    },
    setResourceName: (state, action) => {
      state.resourceName = action.payload;
    },
  },
});

export const podActions = pod.actions;

export default pod.reducer;
